export enum UploadFolderListActionTypes {
  viewFolder = 'viewFolder',
  createReport = 'createReport'
}